<div class="container speedcheck-footer">
    <div class="row">

        <div class="col-12 col-sm-6">
            <div class="footer-element text-center">
                <div *ngIf="!ipv4 && !ipv6">
                    <div class="spinner"></div>
                </div>
                <div *ngIf="ipv4">
                    <span class="descriptor">IPv4: </span><span class="footer-text">{{ipv4}}</span>
                </div>
                <div *ngIf="ipv6">
                    <span class="descriptor">IPv6: </span><span class="footer-text">{{ipv6}}</span>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-6">
            <div class="footer-element text-center" style="text-align: left;">
                <span class="descriptor">{{ 'provider.title' | translate }}</span><br>
                <div *ngIf="!isp">
                    <div class="spinner"></div>
                </div>
                <div *ngIf="isp">
                    <span class="footer-text">{{isp}}</span>
                </div>
            </div>
        </div>

    </div>
    
</div>